import React from "react";
import { withStyles } from "@material-ui/core";
import { sortBy, uniqBy } from "lodash";
import CustomSelect from "../CustomSelect";
import reportConstants from "../../constants";
import { checkDriverHasDelayRoutes } from "../../util";
import {
  VIOLATIONS_FILTER_LIST,
  DRIVER_STATUS_FILTER_LIST,
  SORT_OPTIONS_LIST,
  SORT_TIME_FIELDS,
} from "./constants";
const styles = (theme) => ({
  filterContainer: {
    display: "flex",
    width: "100%",
    marginLeft: 20,
    alignItems: "center",
  },
  dropDownContainer: {
    display: "flex",
    width: "100%",
    marginLeft: 16,
    flexWrap: "wrap",
  },
  filterHeading: {
    fontSize: 12,
    fontWeight: 600,
    color: theme.iconColor,
  },
});

class DriverPerformanceFilters extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      driverNameFilter: [],
      driverStatusFilter: [],
      equipmentTypeFilter: [],
      violationsFilter: "",
      sortControl: "",
      allDrivers: [],
      allTrailers: [],
    };
    this.allViolations = VIOLATIONS_FILTER_LIST;
    this.allDriverStatus = DRIVER_STATUS_FILTER_LIST;
    this.allSortOptions = SORT_OPTIONS_LIST;
  }

  componentDidMount() {
    this.updateDropdowns();
  }

  updateDropdowns = () => {
    this.setState({
      allDrivers: this.getAllDrivers(),
      allTrailers: this.getAllTrailerTypes(),
    });
  };

  componentDidUpdate(prevProps) {
    if (this.props.isDataRefreshed) {
      this.updateAllFilters();
      this.updateDropdowns();
      return;
    }
    if (
      this.props.terminalId !== prevProps.terminalId ||
      (this.props.data && this.props.data !== prevProps.data)
    ) {
      this.resetSelectedValues();
      this.updateDropdowns();
    }
  }

  handleDropdownChange = (selectedValue, event) => {
    const { name } = event;
    this.setState(
      {
        [name]: selectedValue,
      },
      this.updateAllFilters
    );
  };

  updateAllFilters = () => {
    const driverNameFilter = this.state.driverNameFilter?.map(
      (driverOption) => driverOption.value
    );
    const driverStatusFilter = this.state.driverStatusFilter?.map(
      (statusOption) => statusOption.value
    );
    const equipmentTypeFilter = this.state.equipmentTypeFilter?.map(
      (equipmentTypeOption) => equipmentTypeOption.value
    );
    const violationsFilter = this.state.violationsFilter?.value;
    const sortOptionSelected = this.state.sortControl?.value;
    const filteredData = this.props.data?.filter(
      (data) =>
        this.isIncludes(data, "driverId", driverNameFilter) &&
        this.isIncludes(data, "driverStatus", driverStatusFilter) &&
        this.isIncludesTrailerType(data, "trailerType", equipmentTypeFilter) &&
        this.isIncludesViolation(data, violationsFilter)
    );
    this.props.updateFilteredData(
      sortOptionSelected
        ? this.sortFilteredData(filteredData, sortOptionSelected)
        : filteredData
    );
  };

  sortFilteredData = (filteredData, sortOptionSelected) => {
    return sortBy(filteredData, [
      (data) =>
        Object.values(SORT_TIME_FIELDS).includes(sortOptionSelected)
          ? new Date(data[sortOptionSelected])
          : data[sortOptionSelected],
    ]);
  };

  resetSelectedValues = () => {
    this.setState({
      driverNameFilter: [],
      driverStatusFilter: [],
      equipmentTypeFilter: [],
      violationsFilter: "",
      sortControl: "",
    });
  };

  isIncludes = (data, fieldName, selectedDropdown) => {
    return (
      !selectedDropdown.length || selectedDropdown.includes(data[fieldName])
    );
  };

  isIncludesTrailerType = ({ routes }, fieldName, selectedDropdown) => {
    return (
      !selectedDropdown.length ||
      routes
        .map((route) => route[fieldName])
        .some((value) => selectedDropdown.includes(value))
    );
  };

  isIncludesViolation = (data, selectedDropdown) => {
    const { DISPATCH_STOP_STATUS_TYPES } = reportConstants;
    const violation = checkDriverHasDelayRoutes(data, this.props.dispatchDate)
      ? DISPATCH_STOP_STATUS_TYPES.DELAYED
      : DISPATCH_STOP_STATUS_TYPES.ONTIME;
    return !selectedDropdown || selectedDropdown.includes(violation);
  };

  getAllTrailerTypes = () => {
    let allTrailerTypes = [];
    this.props.data?.forEach((driver) => {
      driver.routes.forEach((route) => {
        allTrailerTypes.push({
          label: route.trailerType,
          value: route.trailerType,
        });
      });
    });
    return uniqBy(allTrailerTypes, "value");
  };

  getAllDrivers = () => {
    return uniqBy(
      this.props.data?.map((driver) => ({
        label: driver.driverName,
        value: driver.driverId,
      })),
      "value"
    );
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.filterContainer}>
        <div className={classes.filterHeading}>Filters</div>
        <div className={classes.dropDownContainer}>
          {!this.props.hideDriversFilter && (
            <CustomSelect
              isMulti
              placeholder="Driver"
              name="driverNameFilter"
              value={this.state.driverNameFilter}
              onChange={this.handleDropdownChange}
              options={this.state.allDrivers}
              closeMenuOnSelect={false}
              controlShouldRenderValue={false}
              hideSelectedOptions={false}
            />
          )}
          <CustomSelect
            isMulti
            placeholder="Driver Status"
            name="driverStatusFilter"
            value={this.state.driverStatusFilter}
            onChange={this.handleDropdownChange}
            options={this.allDriverStatus}
            closeMenuOnSelect={false}
            controlShouldRenderValue={false}
            hideSelectedOptions={false}
          />
          <CustomSelect
            isMulti
            placeholder="Equipment Type"
            name="equipmentTypeFilter"
            value={this.state.equipmentTypeFilter}
            onChange={this.handleDropdownChange}
            options={this.state.allTrailers}
            closeMenuOnSelect={false}
            controlShouldRenderValue={false}
            hideSelectedOptions={false}
          />
          {!this.props.hideViolationsFilter && (
            <CustomSelect
              placeholder="Violations"
              name="violationsFilter"
              value={this.state.violationsFilter}
              onChange={this.handleDropdownChange}
              options={this.allViolations}
              isClearable
            />
          )}
          <CustomSelect
            placeholder="Sort By"
            name="sortControl"
            value={this.state.sortControl}
            onChange={this.handleDropdownChange}
            isClearable
            options={this.allSortOptions}
            isSortControl
          />
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(DriverPerformanceFilters);
